module.exports = __webpack_public_path__ + "static/media/notesus.913ea337.gif";